module.exports = __webpack_public_path__ + "static/media/12-min.20c7f4e6.png";